import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGarage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGarage"><Path d="M21.5 19.5H2.5V8.5L12 3.5L21.5 8.5V19.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 15.5H17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 19.5V11.5H6.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGarage;
